import Assignment from './Assignment';
import Queue from './Queue';
import LibraryManagement from './LibraryManagement';

export default {
    Assignment,
    Queue,
    LibraryManagement,
};
